import React from 'react';
import { motion } from 'framer-motion';
import NavigationBar from 'components/ui/NavigationBar';
import Footer from 'components/ui/Footer';
import ExportCapabilities from './landing-page/components/ExportCapabilities';
import ExportProcess from './landing-page/components/ExportProcess';
import QualityAssurance from './landing-page/components/QualityAssurance';

const ServicesPage = () => {
  return (
    <div className="min-h-screen gradient-background-main">
      {/* Navigation Bar */}
      <NavigationBar />
      
      {/* Page Header */}
      <section className="pt-32 pb-12">
        <div className="max-w-7xl mx-auto px-8 lg:px-12 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 0.8 }}
          >
            <h1 className="heading-lg text-text-primary mb-6">
              End-to-End Export Process
            </h1>
            <p className="body-lg text-text-secondary max-w-4xl mx-auto">
              Our streamlined 6-step process ensures your African products reach you with guaranteed quality and on-time delivery.
            </p>
          </motion.div>
        </div>
      </section>
      
      {/* Export Capabilities Timeline */}
      <ExportCapabilities />

      {/* Export Process Walkthrough */}
      <ExportProcess />

      {/* Quality Assurance Gallery */}
      <QualityAssurance />

      {/* Footer */}
      <Footer />
    </div>
  );
};

export default ServicesPage; 